import { render, staticRenderFns } from "./ComparePlansSection.vue?vue&type=template&id=043c245c&scoped=true&"
import script from "./ComparePlansSection.vue?vue&type=script&lang=js&"
export * from "./ComparePlansSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043c245c",
  null
  
)

export default component.exports